module.exports = __webpack_public_path__ + "static/Team4-489eb5832c0fe5f8ba3b3fcd7745c1db.png";